import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacategory,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, BackHandler
} from "react-native";
import HMActionBar from "../../../customviews/HMActionBar";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
import i18n from '../../../I18n/i18n.js';
import {moderateScale} from "../../../tools/Scaling";

import HMTextInput from "../../../customviews/HMTextInput";
import HMTextView from "../../../customviews/HMTextView";
import Colors from "../../../tools/Colors";
import * as NavigationService from "../../../redux/NavigationService";
import DialogConnectionCustomize from "../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../customviews/DialogLoadingCustomize";
import store from "../../../redux/store";
import {typeExport} from "../../../redux/store/type";
import moment from "moment-jalaali";
import Steps from "../../../customviews/steps/Steps";


//moment.locale("fa", fa);
moment.locale("fa");
moment.loadPersian();
let container = null;

const WINDOW_WIDTH = Dimensions.get('window').width;
const BASE_PADDING = 10;
let content = null;
import HMFiles from "../../../customviews/file/HMFiles";
import HMFilesTest from "../../../customviews/file/HMFilesTest";

const firstIndicatorConfigs = {
    stepIndicatorSize: 30,
    currentStepIndicatorSize: 40,
    separatorStrokeWidth: 3,
    currentStepStrokeWidth: 4,
    separatorFinishedColor: '#4aae4f',
    separatorUnFinishedColor: '#a4d4a5',
    stepIndicatorFinishedColor: '#4aae4f',
    stepIndicatorUnFinishedColor: '#a4d4a5',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: 15,
    currentStepIndicatorLabelFontSize: 15,
    stepIndicatorLabelCurrentColor: '#000000',
    stepIndicatorLabelFinishedColor: '#ffffff',
    stepIndicatorLabelUnFinishedColor: 'rgba(255,255,255,0.5)',
    labelColor: '#666666',
    labelSize: 12,
    currentStepLabelColor: '#4aae4f',
};

var sound = null
//Sound.setCategory('Playback');
export default class SubmitRequestOperationFireScreen extends Component {

    constructor(props) {
        super(props);
        container = this;
        let {item, res} = this.props.route.params
        // let arr = store.getState().reducerSplashGetAllData.resultsSaina.result.list;
        // arr = arr.find(({type}) => type == item.type);
        // arr = (arr && arr !== null ? arr.subjects : [])
        content = this;
        // let listMenus = store.getState().reducerSplashGetAllData.resultsShahrdar.result.status;
        // let listMenus = res.result;
        let listMenus = [];
        // let listPlace = [];
        let addressMap = "fghjfg"

        this.state = {
            currentPage: 0,

            indexSelectedArray1: -1,
            itemSelectedArray1: null,

            itemSelectedArray1Sub: null,
            indexSelectedArray1Sub: -1,

            indexSelectedArray2: -1,
            itemSelectedArray2: null,


            indexSelectedArray2Sub: -1,
            itemSelectedArray2Sub: null,


            pageDataArray1Sub: [],
            pageDataArray2: [],
            pageDataArray2Sub: [],
            typeButton: "next",
            name: '',
            description: '',
            arrData: [],
            listName: [],


            modalHeight: 0,

            dataSourcearraycategory: [],
            categoryInput: null,
            arraycategory: [],
            Category: {id: 0, value: i18n.t('constant.selectCategory')},

            arrayCategoryType: [],
            categoryTypeInput: null,
            dataSourcearrayCategoryType: [],
            CategoryType: {id: 0, value: i18n.t('constant.selectCategoryType')},

            //   arrayBedrooms: props.DataSplashScreen.results.bedrooms,
            textarrayBedrooms: null,
            dataSourcearrayBedrooms: [],
            bedrooms: {id: 0, value: i18n.t('constant.selectBedrooms')},


            address: addressMap,
            desc: null,


            min: null,
            max: null,
            size: null,

            Modalcategory: false,
            pickedcategory: null,

            visibleCategoryType: false,
            pickedCategoryType: null,

            visibleModal: '',

            ShowImage: false,
            ShowVideo: false,
            ShowAudio: false,

            pathImage: null,
            pathImageVideo: null,
            pathVideo: null,

            index: 0,

            checked: false,
            pathCompress: null,


            currentTime: 0.0,
            playSeconds: 0.0,
            recording: false,
            paused: false,
            stoppedRecording: true,
            finished: false,
            // audioPath: AudioUtils.DocumentDirectoryPath + '/' + new Date().getTime() + '.aac',
            audioPath: null,
            hasPermission: undefined,
            prepareRecord: true,


            playState: 'record', //playing, paused ,record , stop
            duration: 0,

            arrImage: [],
            alaki: false
        }
        //this.pageDataArray = ['انتخاب وضعیت', 'ضمیمه فایل', 'درج توضیحات'];
        this.pageDataArray = ['', '', ''];
        //  arr.find(({type}) => type == item.type)
        //type=0 => category ,type=1 => not category ,
        this.pageDataArray1 = listMenus
        props.callserviceActionRefresh()

    }

    selectListInFlatlist(index) {
        let d = null
        switch (index) {
            case 0:
                d = this.pageDataArray1

                this.nextEmpty(d, this.state.indexSelectedArray1)

                return d

            // case 1:
            //     d = this.pageDataArray1[this.state.indexSelectedArray1].subjects
            //     this.nextEmpty(d, this.state.indexSelectedArray1Sub)
            //     return d

            /*      case 2:
                      d = this.pageDataArray2
                      this.nextEmpty(d, this.state.indexSelectedArray2)
                      return d


                  case 3:

                      // d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                      d = this.pageDataArray2[this.state.indexSelectedArray2].subplaces
                      this.nextEmpty(d, this.state.indexSelectedArray2Sub)
                      return d*/


        }
    }

    goToIndex(index) {
        setTimeout(function () {


            try {
                content.list.scrollToIndex({animated: true, index: index});

            } catch (e) {

            }

            // alert("df")
        }, 400)
        /*    setTimeout(function(){

                //Put All Your Code Here, Which You Want To Execute After Some Delay Time.
                Alert.alert("Alert Shows After 5 Seconds of Delay.")

            }, 1000);*/
    }

    nextEmpty(data, index) {

        if (data && data.length > 0) {

            this.goToIndex(index, data)
        } else {
            this.setState({
                    currentPage: this.state.typeButton === "next" ? this.state.currentPage + 1 : this.state.currentPage - 1
                },
                () => {

                })
        }

    }


    selectTick(index) {
        switch (this.state.currentPage) {
            case 0:

                return this.state.indexSelectedArray1 == index

            case 1:

                return this.state.indexSelectedArray1Sub == index
            case 2:

                return this.state.indexSelectedArray2 == index

            case 3:


                return this.state.indexSelectedArray2Sub == index

        }
    }


    componentWillReceiveProps(propss) {


    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }


    async componentDidMount() {


///////////////////////audio///////////////////////////////
        //  this.prepareRecording()

        ////////////////////////////
        //  this.getAddressOfPoint()
        this.setState({
            dataSourcearraycategory: this.state.arraycategory,
        })
        BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);


    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);

    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    goBack() {
        if (this.state.currentPage >= 1) {
            this.setState({currentPage: this.state.currentPage - 1, typeButton: "back"}
                , () => {

                }
            )
        } else {
            NavigationService.Pop();
        }
    }

    handleScroll(event) {
    }

    _onRef = (property, view) => {
        this[property] = view
    }

    render() {
        let textButtonNext = this.state.currentPage === 1 ? i18n.t('constant.Registration') : i18n.t('constant.next')


        return (
            <View style={{flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>

                        <HMActionBar menu
                                     props={this.props} statusBarTransparent
                            // text={i18n.t('Privatizations.title')}
                                     text={i18n.t('constant.Switching')}
                                     headerVisibility
                                     more_menu
                                     back
                                     onBackPress={() => this.props.navigation.pop()}

                        />
                        <View

                            style={styles.stepIndicator}>

                            <Steps
                                configs={firstIndicatorConfigs}
                                current={this.state.currentPage}
                                // reversed={true}
                                // labels={this.pageDataArray}

                                count={2}
                            />
                        </View>


                        <View ref={(ref) => {
                            this.contView = ref;
                        }} style={{flex: 1}}>

                            <View style={{flex: 1}}>

                                {
                                    this.state.currentPage === 0 ?
                                        //<HMFiles stateParent={this.state} func={container._setDataFiles}/>
                                        <HMFilesTest
                                            stateParent={this.state}
                                            _setStateData={this._setStateData}
                                            // _setStateDataParent={container.props._setStateData}
                                            SizeBox={3}
                                            // styleRoot2={{flexDirection: 'row',}}
                                            //clearState={this.clearState}
                                            styleRoot2={{
                                                flexDirection: 'row',
                                                flexWrap: 'wrap',
                                                width: "100%",

                                                // flexGrow: 1,
                                                //  backgroundColor: "#ee04d0",
                                                alignItems: "flex-start"

                                            }}
                                        />
                                        :
                                        null
                                }

                                {
                                    this.state.currentPage === 1 ?

                                        <View
                                            style={{
                                                position: 'absolute',
                                                flex: 1,
                                                // height:'100%',
                                                // alignContent: 'center',
                                                // alignItems: 'center',
                                                //  justifyContent: 'center',

                                                top: 0,
                                                bottom: 0,
                                                right: 0,
                                                left: 0,
                                                backgroundColor: 'rgba(0,0,0,0.01)',
                                                zIndex: 999
                                            }}>
                                            {/*<TouchableOpacity*/}
                                            {/*onPress={() => this.setState({*/}

                                            {/*//     address: !this.state.checked ? "من در رستوران غذا را تحویل میگیرم" : this.props.user.address,*/}
                                            {/*checked: !this.state.checked,*/}
                                            {/*})}*/}

                                            {/*style={{*/}
                                            {/*flexDirection: "row",*/}
                                            {/*// alignSelf: "flex-end",*/}
                                            {/*marginHorizontal: moderateScale(6),*/}
                                            {/*marginVertical: moderateScale(8)*/}
                                            {/*}}>*/}
                                            {/*<CheckBox*/}
                                            {/*center*/}
                                            {/*//  style={{width:moderateScale(20),height:moderateScale(20),textAlign:'center'}}*/}
                                            {/*color={!this.state.checked ? Colors.colorDark : Colors.red}*/}
                                            {/*checked={this.state.checked} onPress={(check) => {*/}


                                            {/*this.setState({*/}
                                            {/*checked: !this.state.checked,*/}
                                            {/*})*/}


                                            {/*}}/>*/}
                                            {/*<View style={{width: moderateScale(15)}}/>*/}
                                            {/*<View*/}
                                            {/*>*/}
                                            {/*<HMTextView*/}
                                            {/*text="اطلاعاتم بصورت محرمانه باشد"*/}
                                            {/*style={{color: !this.state.checked ? Colors.colorDark : Colors.red}}*/}
                                            {/*/>*/}
                                            {/*</View>*/}

                                            {/*</TouchableOpacity>*/}

                                            {/*<View*/}
                                            {/*style={{*/}
                                            {/*marginHorizontal: moderateScale(8),*/}
                                            {/*height: moderateScale(60),*/}
                                            {/*marginVertical: moderateScale(4)*/}
                                            {/*}}>*/}
                                            {/*<Card>*/}
                                            {/*<CardItem cardBody style={{*/}
                                            {/*paddingLeft: 0,*/}
                                            {/*paddingRight: 0,*/}
                                            {/*paddingTop: 0,*/}
                                            {/*paddingBottom: 0,*/}
                                            {/*}}>*/}
                                            {/*<View*/}
                                            {/*style={{paddingVertical: moderateScale(10)}}*/}
                                            {/*>*/}
                                            {/*<HMTextInput*/}
                                            {/*value={this.state.address}*/}
                                            {/*number*/}
                                            {/*onChangeText={text => {*/}
                                            {/*this.setState({address: text})*/}
                                            {/*}}*/}
                                            {/*//       keyboardType="numeric"*/}
                                            {/*placeholder={i18n.t('constant.PlaceholderAddress')}*/}
                                            {/*style={{*/}
                                            {/*width: "90%",*/}

                                            {/*fontSize: moderateScale(14)*/}
                                            {/*}} underlineColorAndroid="transparent"/>*/}


                                            {/*</View>*/}
                                            {/*</CardItem>*/}
                                            {/*</Card>*/}
                                            {/*</View>*/}


                                            <View
                                                style={{
                                                    paddingVertical: moderateScale(10),
                                                    marginHorizontal: moderateScale(6)
                                                }}
                                            >
                                                <HMTextInput
                                                    value={this.state.description}
                                                    number
                                                    onChangeText={text => {
                                                        this.setState({description: text})
                                                    }}

                                                    _height={moderateScale(100)}
                                                    //   keyboardType="numeric"
                                                    placeholder={i18n.t('constant.PlaceholderDesc')}
                                                    style={{
                                                        // height:moderateScale(100),
                                                        fontSize: moderateScale(14)
                                                    }} underlineColorAndroid="transparent"
                                                    styleInput={{height: moderateScale(80)}}

                                                    // textCenter={'center'}
                                                />


                                            </View>

                                        </View>
                                        :
                                        null
                                }


                            </View>

                            <View
                                style={{
                                    width: '100%',
                                    height: moderateScale(42),
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: moderateScale(8)
                                }}>

                                {


                                    <View
                                        style={{
                                            width: '100%',
                                            height: moderateScale
                                            (42),
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: moderateScale(8)
                                        }}
                                    >
                                        <TouchableOpacity
                                            onPress={() => {
                                                // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                                //this.refs['viewPager'].setPage(this.state.currentPage - 1);

                                                this.goBack();
                                            }}
                                            style={{
                                                flex: .48,
                                                height: moderateScale(42),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.colorPrimary,
                                                borderRadius: moderateScale(6)

                                            }}>

                                            <HMTextView
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                text={i18n.t('constant.Back')} type={"bold"}
                                                style={{
                                                    fontSize: moderateScale(13),
                                                    marginVertical: moderateScale(6),
                                                    marginHorizontal: moderateScale(4),
                                                    color: Colors.white
                                                }}/>
                                        </TouchableOpacity>

                                        <View style={{width: moderateScale(8)}}/>
                                        <TouchableOpacity

                                            onPress={() => {
                                                //   this.refs['viewPager'].setPage(this.state.currentPage + 1);
                                                if (this.state.currentPage < 1) {

                                                    this.setState({
                                                            typeButton: "next",
                                                            currentPage: this.state.currentPage + 1
                                                        }
                                                        , () => {

                                                        }
                                                    )
                                                } else {


                                                    this.setData()
                                                }


                                            }}
                                            style={{
                                                flex: .48,
                                                height: moderateScale(42),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.colorPrimary,
                                                borderRadius: moderateScale(6)
                                            }}>
                                            <HMTextView
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                text={textButtonNext} type={"bold"}
                                                style={{
                                                    fontSize: moderateScale(13),
                                                    marginVertical: moderateScale(6),
                                                    marginHorizontal: moderateScale(4),
                                                    color: Colors.white
                                                }}/>
                                        </TouchableOpacity>
                                    </View>

                                }

                            </View>

                        </View>


                        {/*   {Platform.OS='ios'?
                            <View style={{width:moderateScale(1),height:moderateScale(1)}}>
                            <VideoPlayer
                                ref={ref => this.videoPlayerRef = ref}
                                startTime={30}  // seconds
                                endTime={120}   // seconds
                                play={false}     // default false
                                replay={false}   // should player play video again if it's ended
                                rotate={true}   // use this prop to rotate video if it captured in landscape mode iOS only
                                source={this.state.pathCompress}
                                playerWidth={1} // iOS only
                                playerHeight={1} // iOS only
                                style={{ backgroundColor: 'red' }}
                                resizeMode={VideoPlayer.Constants.resizeMode.CONTAIN}
                              //  onChange={({ nativeEvent }) => {} // get Current time on every second
                            />
                            </View>
                        :
                            null
                        }*/}
                        {
                            this.props.NoInternetDialog ?
                                <DialogConnectionCustomize
                                    onPress={() => this.checkMobile(this.state.mobile)}
                                />
                                :
                                null
                        }
                        {
                            this.props.isLoading || this.props.isLoadingSet || this.state.isLoadingCompress ?
                                <DialogLoadingCustomize
                                    text={this.state.isLoadingCompress ? "درحال کاهش حجم فایل" : null}
                                />
                                :
                                null
                        }
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }


    onChangecategory(index, data) {

        container.setState({
            Category: {value: data.name, id: data.id},
            CategoryType: {value: i18n.t('constant.selectCategoryType'), id: 0},
            arrayCategoryType: data.subjects,
            dataSourcearrayCategoryType: data.subjects,
            visibleModal: ''
        })
    }

// onChangecategory = (index, item) => {
// }
    onChangeCategoryType(index, data) {
        container.setState({
            CategoryType: {value: data.subjects_tks_subject, id: data.subjectsid},
            visibleModal: ''
            //CategoryType: {value: i18n.t('constant.selectCategoryType'), id: 0},

            // arrayCategoryType: data.CategoryType

        })
    }


    _changeTextAddress(text) {
        this.setState({address: text});
    }


    _changeTextDesc(text) {
        this.setState({desc: text});
    }


    _setDataFiles(name, data) {
        container.setState({[name]: data});
    }


    async setData() {
        let {token} = store.getState().reducerSplashGetAllData
        let {item} = this.props.route.params


        if (store.getState().reducerSplashGetAllData.Connection) {
            let paramss = {
                "_operation": typeExport._Fire,
                "mode": 'UploadFile',
                "lang": i18n.locale,
                "token": token,
                "code": item.TrackingCode,

                "AnswerComment": this.state.description,
                "comment": this.state.description,

                "image": this.state.pathImage,
                "video": this.state.pathVideo,
                "audioBlob": this.state.ShowAudio && Platform.OS === "web" ? (this.state.audioBlob) : null,
                "durationVoice": this.state.ShowAudio ? (this.state.durationVoice) : null,
                "audio": this.state.audioPath ? (Platform.OS == 'android' ? 'file://' + this.state.audioPath : this.state.audioPath) : null,
                "date": moment().format("jYYYY/jM/jD HH:mm:ss"),
                "arrImage": this.state.arrImage

            };
            this.props.callService(
                global.UrlWebService125,
                paramss,
                typeExport.TypeSetSubmitRequestOperationFireScreen,
                "POST",
                token
            );
            //this.GoScreen()
            //     }
            // }
        } else {
            /*  let list = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListOperatorApplyOffline + item.type);
              let data = {
                  "_operation": typeExport._Contacts,
                  "mode": "SaveTickets",
                  "lang": i18n.locale,
                  "token": token,
                  "type": item.type,

                  "image": this.state.pathImage,
                  "video": this.state.pathVideo,
                  "audio": this.state.ShowAudio ? (Platform.OS == 'android' ? 'file://' + this.state.audioPath : this.state.audioPath) : null,

                  // "category": this.state.Category.value,
                  // "subject": this.state.CategoryType.value,
                  // "subjectid": this.state.CategoryType.id,

                  "category": this.state.itemSelectedArray1.name,
                  "subject": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.subjects_tks_subject ? this.state.itemSelectedArray1Sub.subjects_tks_subject : this.state.itemSelectedArray1.name,
                  "subjectid": this.state.itemSelectedArray1Sub && this.state.itemSelectedArray1Sub.subjectsid ? this.state.itemSelectedArray1Sub.subjectsid : this.state.itemSelectedArray1.id,


                  "description": this.state.description,
                  //  "address": this.state.address,
                  // "longitude": this.props.route.params.position.long,
                  // "latitude": this.props.route.params.position.lat,
                  "index": (list != null && list.length > 0) ? list.length + 1 : 1,
                  "date": moment().format("jYYYY/jM/jD HH:mm:ss"),
                  //   "private": this.state.checked ? "1" : "0",
                  //"token_fb": this.props.DataSplashScreen.token_fb,
              };


              if (list != null && list.length > 0) {
                  list.push(data)

              } else {
                  list = [];
                  list.push(data)
              }


              await
                  AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListOperatorApplyOffline + item.type, list)
              // this.props.callServiceListNotSendMyApply(list)
              store.dispatch(serviceActionListNotSendMyApply(list));
              Alert.alert(
                  i18n.t('constant.message'),
                  i18n.t('constant.RequestSuccessfullyRegistered'),
                  [
                      // {text: 'Ask me later', onPress: () => {}},
                      {
                          text: i18n.t('constant.ok'), onPress: () => {
                              NavigationService.BackTo(2)
                              //  NavigationService.navigatereset("ApplyScreen", {item: item})
                          }
                          //  NavigationService.navigatereset("ApplyScreen",{item: item})

                          , style: 'cancel'
                      },

                  ],
                  {cancelable: true}
              )
  */
            Alert.alert(
                i18n.t('constant.message'),
                i18n.t('constant.retry'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                            // NavigationService.BackTo(2)
                            //  NavigationService.navigatereset("ApplyScreen", {item: item})
                        }
                        //  NavigationService.navigatereset("ApplyScreen",{item: item})

                        , style: 'cancel'
                    },

                ],
                {cancelable: true}
            )
        }


    }
    _setStateData(object) {
        container.setState(object);
    }
}

const styles = StyleSheet.create({
    /* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: "100%",
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    container: {
        paddingHorizontal: BASE_PADDING,
    },
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
        marginLeft: -BASE_PADDING,
        marginRight: -BASE_PADDING,
    },
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    carousel: {
        height: WINDOW_WIDTH - BASE_PADDING * 2,
        width: WINDOW_WIDTH - BASE_PADDING * 2,
        backgroundColor: 'white',
    },
    text: {
        marginVertical: BASE_PADDING * 2,
    },
    stepIndicator: {
        marginVertical: moderateScale(6)
    },
    page: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    progressText: {

        paddingTop: moderateScale(50),
        fontSize: moderateScale(50),
        color: "#fff",
    },
    progressTextPlay: {
        paddingTop: moderateScale(25),
        fontSize: moderateScale(25),
        color: "#fff"
    },
    button: {
        padding: moderateScale(20)
    },
    disabledButtonText: {
        color: '#eee'
    },
    buttonText: {
        fontSize: moderateScale(20),
        color: "#fff"
    },
    activeButtonText: {
        fontSize: moderateScale(20),
        color: "#B81F00"
    }
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});
